import { Validators } from '@angular/forms';
import { CategoriesService } from '../../pages/categories/categories.service';
import { PageService } from '../../pages/pages/page.service';
import { UsersService } from '../../../shared/users.service';


export const MODEL_CONFIG: Record<string, any> = {
  category: {
    successMSG: {create: "category_create_success", update: "category_update_success", delete: "category_delete_success"},
    errorMSG: {create: "category_create_failed", update: "category_update_failed", delete: "category_delete_failed"},
    fields: {
      label: { label: 'label', type: 'text', validators: [Validators.required],  },
      parent_cate_id: { label: 'parent_cate_id', type: 'select', validators: [Validators.required], options: [{label:"",value:""}], fetchUrl: "api/category/"  },
      icon: { label: 'icon', type: 'select', validators: [Validators.required],  options: [
          { label: 'Insights', value: 'mat:insights', icon:"mat:insights" },
          { label: 'Dashboard', value: 'mat:dashboard', icon: "mat:dashboard" },
          { label: 'Settings', value: 'mat:settings', icon: "mat:settings" },
          { label: 'Account', value: 'mat:account_circle', icon: "mat:account_circle" },
          { label: 'Security', value: 'mat:security', icon: "mat:security" },
          { label: 'Notifications', value: 'mat:notifications', icon: "mat:notifications" },
          { label: 'Help', value: 'mat:help', icon: "mat:help" },
          { label: 'Logout', value: 'mat:logout', icon: "mat:logout" }
        ] }
    },
    service: CategoriesService
  },
  page: {
    successMSG: {create: "page_create_success", update: "page_update_success", delete: "page_delete_success"},
    errorMSG: {create: "page_create_failed", update: "page_update_failed", delete: "page_delete_failed"},
    fields: {
      title: { label: 'title', type: 'text', validators: [Validators.required] },
      short_description: { label: 'short_description', type: 'text', validators: [Validators.required] },
      category: { label: 'category', type: 'select', validators: [Validators.required], options: [{label:"",value:""}], fetchUrl: "api/category/"  },
      image: { label: 'image', type: 'image', validators: [Validators.required] },
      content: { label: 'content', type: 'textarea', validators: [Validators.required] },

    },
    service: PageService
  },
  user: {
    successMSG: {create: "user_create_success", update: "user_update_success", delete: "user_delete_success"},
    errorMSG: {create: "user_create_failed", update: "user_update_failed", delete: "user_delete_failed"},
    fields: {
      username: { label: 'username', type: 'text', validators: [Validators.required], pattern: /^[A-Za-z0-9]+$/ },
      email: { label: 'email', type: 'email', validators: [Validators.required], pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ },
      first_name: { label: 'first_name', type: 'text', validators: [Validators.required] },
      last_name: { label: 'last_name', type: 'text', validators: [Validators.required] },
      role: { label: 'role', type: 'select', validators: [Validators.required], options: [
          { label: 'Student', value: 'student', icon:"logo:student" },
          { label: 'Teacher', value: 'teacher', icon: "logo:teacher" },
        ]},
      avatar: { label: 'avatar', type: 'image', validators: [Validators.required] },
    },
    service: UsersService
  },
  add_student: {
    successMSG: {create: "student_create_success", update: "student_update_success", delete: "student_delete_success"},
    errorMSG: {create: "student_create_failed", update: "student_update_failed", delete: "student_delete_failed"},
    fields: {
      username: { label: 'username', type: 'text', validators: [Validators.required], pattern: /^[A-Za-z0-9]+$/  },
      email: { label: 'email', type: 'email', validators: [Validators.required], pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ },
      first_name: { label: 'first_name', type: 'text', validators: [Validators.required] },
      last_name: { label: 'last_name', type: 'text', validators: [Validators.required] },
      role: { label: 'role', type: 'select', validators: [Validators.required], attributes:[{disable: true}], options: [
          { id:'student', label: 'Student', value: 'student', icon:'logo:student' },
          { id:'teacher',label: 'Teacher', value: 'teacher', icon: 'logo:teacher' },
        ]},
      password: { label: 'password', type: 'text', validators: [Validators.required], pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.^#_])[A-Za-z\d@$!%*?&.^#_]{8,}$/ },
      avatar: { label: 'avatar', type: 'image', validators: [Validators.required] },
    },
    service: UsersService
  },
  add_teacher: {
    successMSG: {create: "teacher_create_success", update: "teacher_update_success", delete: "teacher_delete_success"},
    errorMSG: {create: "teacher_create_failed", update: "teacher_update_failed", delete: "teacher_delete_failed"},
    fields: {
      username: { label: 'username', type: 'text', validators: [Validators.required], pattern: /^[A-Za-z0-9]+$/  },
      email: { label: 'email', type: 'email', validators: [Validators.required], pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ },
      first_name: { label: 'first_name', type: 'text', validators: [Validators.required] },
      last_name: { label: 'last_name', type: 'text', validators: [Validators.required] },
      role: { label: 'role', type: 'select', validators: [Validators.required], attributes:[{disable: true}], options: [
          { id:'student', label: 'Student', value: 'student', icon:'logo:student' },
          { id:'teacher',label: 'Teacher', value: 'teacher', icon: 'logo:teacher' },
        ]},
      password: { label: 'password', type: 'text', validators: [Validators.required], pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.^#_])[A-Za-z\d@$!%*?&.^#_]{8,}$/ },
      avatar: { label: 'avatar', type: 'image', validators: [Validators.required] },
    },
    service: UsersService
  }

};
